module.exports = __webpack_public_path__ + "img/header-weddingRingsPalladium.35d40fc.webp";